"use client";

import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useState,
} from "react";

// ----------------------------------------------------------------------------

export type ILeadershipBlogsSubCategoryContext = {
  // Multiselect: Please remove and uncomment below lines
  activeBlogsByFunctions: string;
  activeBlogsByProcesses: string;
  activeBlogsByRoles: string;
  setActiveBlogsByFunctions: Dispatch<SetStateAction<string>>;
  setActiveBlogsByProcesses: Dispatch<SetStateAction<string>>;
  setActiveBlogsByRoles: Dispatch<SetStateAction<string>>;
  // activeBlogsByFunctions: string[];
  // activeBlogsByProcesses: string[];
  // activeBlogsByRoles: string[];
  // setActiveBlogsByFunctions: Dispatch<SetStateAction<string[]>>;
  // setActiveBlogsByProcesses: Dispatch<SetStateAction<string[]>>;
  // setActiveBlogsByRoles: Dispatch<SetStateAction<string[]>>;
};

export type ILeadershipBlogsSubCategoryProviderProps = {
  children: ReactNode;
};

export const leadershipBlogsSubCategoryContext =
  createContext<ILeadershipBlogsSubCategoryContext>(
    {} as ILeadershipBlogsSubCategoryContext,
  );

export const LeadershipBlogsSubCategoryProvider: FC<
  ILeadershipBlogsSubCategoryProviderProps
> = (props) => {
  const { children } = props;

  // Multiselect: Please remove and uncomment below lines
  const [activeBlogsByFunctions, setActiveBlogsByFunctions] = useState("ALL");
  const [activeBlogsByProcesses, setActiveBlogsByProcesses] = useState("ALL");
  const [activeBlogsByRoles, setActiveBlogsByRoles] = useState("ALL");
  // const [activeBlogsByFunctions, setActiveBlogsByFunctions] = useState<
  //   string[]
  // >([]);
  // const [activeBlogsByProcesses, setActiveBlogsByProcesses] = useState<
  //   string[]
  // >([]);
  // const [activeBlogsByRoles, setActiveBlogsByRoles] = useState<string[]>([]);

  return (
    <leadershipBlogsSubCategoryContext.Provider
      value={{
        activeBlogsByFunctions,
        activeBlogsByProcesses,
        activeBlogsByRoles,
        setActiveBlogsByFunctions,
        setActiveBlogsByProcesses,
        setActiveBlogsByRoles,
      }}
    >
      {children}
    </leadershipBlogsSubCategoryContext.Provider>
  );
};
